module.exports = __webpack_public_path__ + "img/work_together.c5aed32c.svg";